// test725
(725 && 0);
